export function useRequestInlineTemplate() {
    const requestChartInlineTemplate = (symbol) => {
        const route = window.route('api.chart-template');

        return axios.post(route, {symbol})
            .then((response) => {
                const elem = document.getElementById('barchart-www-inline-data');

                let json = {};

                if (elem.innerHTML.length > 0) {
                    json = JSON.parse(elem.innerHTML);
                }

                Object.keys(response.data.data).map(symbol => {
                    json[symbol] = response.data.data[symbol];
                });

                elem.innerHTML = JSON.stringify(json);
            }).catch((error) => {
                console.error(error);
                return Promise.reject(error);
            })
    };

    return {
        requestChartInlineTemplate,
    };
};
